import PropTypes from 'prop-types';
import HspDropdown from '../../Dropdowns/HspDropdown/HspDropdown';
import {getDisplayValue} from './chooseTubingUtils';

/**
 * Stateless dropdown for tubing diameter selection.
 */
function DiameterDropdown({
  choices,
  design,
  isCompatible,
  heatshrinkCompatibility,
  lastSelected,
  compatibilityLookup,
  onSelect: _onSelect,
  util
}) {
  return (
    <HspDropdown
      label={{labelContent: 'Diameter (D)', labelKey: 'diameter'}}
      topLevelClassNames={
        !isCompatible &&
        heatshrinkCompatibility?.safestActions?.includes('diameter') &&
        lastSelected !== 'diameter'
          ? 'has-error'
          : ''
      }
      dropdownMenuItems={choices}
      dropdownToggleItems={{
        isDropdownActive: false,
        dropdownText: getDisplayValue('diameter', design.diameter, util),
        dropdownClasses:
          !compatibilityLookup['diameter'] && lastSelected !== 'diameter' ? 'not-compatible' : ''
      }}
    />
  );
}

DiameterDropdown.propTypes = {
  choices: PropTypes.array.isRequired,
  design: PropTypes.object.isRequired,
  isCompatible: PropTypes.bool.isRequired,
  heatshrinkCompatibility: PropTypes.object,
  lastSelected: PropTypes.string.isRequired,
  compatibilityLookup: PropTypes.object.isRequired,
  onSelect: PropTypes.func,
  util: PropTypes.object.isRequired
};

export default DiameterDropdown;
